import { DECIMAL, SPECIALALPHANUMERIC } from './../../../../Components/Forms/constant_form';
import Dollar from './../../../../Assets/Img/Icons/dollar.svg'

export const formFields = [
	{
		forms: [
      {
				label: 'Name',
				placeholder: 'Type setting name',
				type: 'text',
				col: 'col-12',
				required: true,
				validate: {
					type: SPECIALALPHANUMERIC
				},
				name: 'name'
			},
      {
				label: 'Cost',
				icon: <img className="icon pa-2" alt="login icon" src={Dollar} />,
				type: 'text',
				col: 'col-12',
				required: true,
				validate: {
					type: DECIMAL
				},
				name: 'amount'
			}
		]

	}

];
